import React from 'react';
import useFetch from "hooks/useFetch";
import useDestination from "hooks/useDestination";
import useGaPageView from "hooks/useGaPageView";
import FoodCourtLayout from "components/Layout/FoodCourtLayout";
import Title from "components/shared/SingleDetails/Title";
import MenuFeatures from "components/shared/SingleDetails/MenuFeatures";
import Menu from "components/shared/SingleDetails/Menu";
import styles from "./FoodCourtDetail.module.css" 
import MapRouterMaster from 'containers/MapRouterMaster';
import { withRouter } from 'react-router-dom';
import { mapRouterType, screenKeys, gaSettings } from "config/constants";
import { mainApiPath } from "api/constants"

function FoodCourtDetail(props) {
    const [error, loading, data] = useFetch(mainApiPath.foodcourt_details  + '/' + props.match.params.id);
    const destination = useDestination( props.location.search);

    const gaTitle = gaSettings.foodcourtDetail.title;
    const gaLocation = data?.title
      ? gaSettings.foodcourtDetail.location + data.title
      : null;
    useGaPageView({ gaTitle, gaLocation });

    return(
        <FoodCourtLayout 
            error={error} 
            goBack={screenKeys.foodcourt}
            loading={loading}
            left ={
                <>
                    <Title title={data ? data.title : null} loading={loading} /> 
                    <MapRouterMaster 
                        type={mapRouterType.pathGuide} 
                        bannerSrc={data ? data.banner : null} 
                        slotInfo={destination} 
                        layout={'restaurant'} 
                        destinationName={data ? data.title : ''} 
                    />
                </>
            }

            right ={
                <>
                    <div className={styles.wrapp_menu_foodcord}>
                        <MenuFeatures  menuFeatures={ data ? data.menu_features : null} loading={loading}/>
                    </div>

                    <div className={styles.wrapper_menu}>
                        <Menu menus={ data ? data.menu : null} loading={loading}/>
                    </div>   
                </>  
            }
        />
    );
}
export default withRouter(FoodCourtDetail);